import { render } from "./ArtistProfileEdit.vue?vue&type=template&id=b71fdff4&scoped=true"
import script from "./ArtistProfileEdit.vue?vue&type=script&lang=js"
export * from "./ArtistProfileEdit.vue?vue&type=script&lang=js"

import "./ArtistProfileEdit.vue?vue&type=style&index=0&id=b71fdff4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b71fdff4"]])

export default __exports__